module.exports = __webpack_public_path__ + "img/筆記裝飾星星大.5eba9052.svg";